import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María Fernanda S.',
  role: 'Terapeuta Holística',
  text: 'El nivel de profundidad de este curso es increíble. Llevaba años leyendo el Tarot de forma intuitiva, pero la estructura que me dio la formación cambió por completo mis consultas.'
}, {
  name: 'Carlos R.',
  role: 'Principiante',
  text: 'Empecé desde cero absoluto. Los tomos son súper didácticos y fáciles de entender. Ya estoy haciendo mis primeras lecturas con mucha seguridad. ¡Totalmente recomendado!'
}, {
  name: 'Elena G.',
  role: 'Astróloga',
  text: 'El material en PDF es de una calidad excepcional. Lo tengo en mi tablet y lo consulto constantemente. El módulo de Tarot Evolutivo es una joya que complementa perfecto mi trabajo.'
}, {
  name: 'Lucía M.',
  role: 'Tarotista',
  text: 'Los 12 tomos son la mejor inversión que he hecho en mi educación esotérica. Todo está explicado con claridad y con un enfoque realmente profesional.'
}, {
  name: 'Andrea V.',
  role: 'Coach de Vida',
  text: 'Integro las tiradas terapéuticas en mis sesiones de coaching y los resultados con mis clientes son asombrosos. El diccionario de las 78 cartas me salvó la vida al principio.'
}, {
  name: 'Sofía P.',
  role: 'Estudiante',
  text: 'Me encantó que el acceso sea de por vida. Estudio a mi propio ritmo entre el trabajo y la universidad. El diseño de los manuales es hermoso y muy profesional.'
}];
export function Testimonials() {
  return <section className="py-20 relative z-10 bg-mystic-900/50" data-id="element-200">
      <div className="container mx-auto px-4" data-id="element-201">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-202">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-203">
            Opiniones de nuestros alumnos
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-204"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-205">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-mystic-800 border border-mystic-700 p-6 rounded-2xl relative" data-id="element-206">
              <div className="flex text-gold mb-4" data-id="element-207">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-208" />)}
              </div>
              <p className="text-white/80 mb-6 italic" data-id="element-209">"{t.text}"</p>
              <div className="mt-auto" data-id="element-210">
                <div className="font-bold text-white" data-id="element-211">{t.name}</div>
                <div className="text-sm text-gold/80" data-id="element-212">{t.role}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}